<template>
  <router-view v-if="isRouterAlive"  :key="$route.fullPath"></router-view>
</template>

<script setup>

// 刷新
import { ref , nextTick, provide  ,onMounted ,onBeforeUnmount } from 'vue'
// 局部组件刷新
const isRouterAlive = ref(true);
const reload = () => {
  console.log('进入');
  isRouterAlive.value = false;
  nextTick(() => {
    isRouterAlive.value = true;
  });
};
provide("reload", reload);


import { useStore } from "vuex";

const store = useStore(); 

  let  screenWidth = ref(0)
  let  screenHeight= ref(0)
  const handleScreenResize =()=> {
      screenWidth = window.screen.width;
      screenHeight = window.screen.height;
      // console.log(screenWidth,screenHeight);
      store.commit('screenWH',{'w':screenWidth,'h':screenHeight},)
      // console.log(store.state.screenWidth);
  }

  import WOW from "wow.js";

onMounted(() => {
    handleScreenResize()
    window.addEventListener('resize', handleScreenResize)
    // console.log('------------------------')
    // console.log('onMounted 组件视图渲染之后（生命周期钩子）')
    var wow = new WOW({
      boxClass: "wow", // animated element css class (default is wow)
      animateClass: "animated", // animation css class (default is animated)
      offset: 10, // distance to the element when triggering the animation (default is 0)
      mobile: true, // trigger animations on mobile devices (default is true)
      live: true, // act on asynchronously loaded content (default is true)
      callback: function () {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null, // optional scroll container selector, otherwise use window,
      resetAnimation: true, // reset animation on end (default is true)
    });
    wow.init();

})
  onBeforeUnmount(() =>{
    window.removeEventListener('resize', handleScreenResize)
  })
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center; */
  color: #2c3e50;
  /* font-family: "MyFont"; */
  width: 100%;
  height: 100%;
  
}
html,body{
		height: 100%;
	}
</style>
